import React from 'react';
import '../less/united_country.less';
import Banner from './../../../../auxiliary-components/shared/Banner';
import choose_winners_img from '../img/choose_winners_img.png';
import united_country_banner_img from '../img/united_country_banner_img.png';
import stages from '../enums/stages.json';
import FilesForDownload from './../../../../auxiliary-components/shared/FilesForDownload';
import { pr_page_subscribe_instagram } from '../../../../services/urls/urls';
import Tariffs from '../../../../auxiliary-components/shared/TariffsBlock';
import task_table_data from '../enums/task_table_data.json';
import { Preloader } from 'MWComponents';
import { canUseDOM } from '../../../../helpers/canUseDOM';

export default function template() {
    const isMobile = this.isViewportMobile();
    const bannerDatesBlock = (
      <div className='united-country-block banner-dates'>{this.l10n('UNITED_COUNTRY_BANNER_DATES')}</div>
    );
    const stageBlocks = stages.map((el, idx) => (
      <div className="bottom-choose-winners__column" key={idx}>
        <div className="bottom-choose-winners__item">
          <div className="bottom-choose-winners__subtitle">{this.l10n(el.subtitle)}</div>
          <div className="bottom-choose-winners__text">{this.l10n(el.text)}</div>
        </div>
      </div>
    ));

  return (
      <div className='united-country'>
        <Banner
            text={'UNITED_COUNTRY_BANNER_SUBTITLE'}
            textMob={'UNITED_COUNTRY_BANNER_SUBTITLE'}
            title={'UNITED_COUNTRY_BANNER_TITLE'}
            page={'united_country'}
            isMobile={isMobile}
            img={united_country_banner_img}
            complDates
            dates={bannerDatesBlock}
        ></Banner>
        <div className='content'>
          <div className="prizes">
            <h2 className="prizes__title">{this.l10n('UNITED_COUNTRY_PRIZES_TITLE')}</h2>
            <div className="prizes__text">
              <ul>
                <li>{this.l10n('UNITED_COUNTRY_PRIZES_TEXT_01')}</li>
                <li>{this.l10n('UNITED_COUNTRY_PRIZES_TEXT_02')}</li>
              </ul>
            </div>
          </div>
          <div className="conditions">
            <h2 className="conditions__title">{this.l10n('UNITED_COUNTRY_CONDITIONS_TITLE')}</h2>
            <div className="conditions__text">{this.l10n('UNITED_COUNTRY_CONDITIONS_TEXT')}</div>
            <div className="task">
              <h3 className="task__title">{this.l10n('UNITED_COUNTRY_TASK_TITLE')}</h3>
              <Tariffs
                items={task_table_data}
              />
              <div className="task__hint">{this.l10n('UNITED_COUNTRY_TASK_HINT')}</div>
              <div className="task__text">{this.l10n('UNITED_COUNTRY_TASK_TEXT')}</div>
            </div>
          </div>
          <div className="choose-winners">
            <div className="choose-winners__top top-choose-winners">
              <h2 className="top-choose-winners__title">{this.l10n('UNITED_COUNTRY_TOP_CHOOSE_WINNERS_TITLE')}</h2>
              <div className="top-choose-winners__text">{this.l10n('UNITED_COUNTRY_TOP_CHOOSE_WINNERS_TEXT')} <a href={pr_page_subscribe_instagram} target='_blank' rel="noopener noreferrer">{this.l10n('UNITED_COUNTRY_TOP_CHOOSE_WINNERS_LINK')}</a></div>
            </div>
            <div className="choose-winners__bottom bottom-choose-winners">
              <h3 className="bottom-choose-winners__title">{this.l10n('UNITED_COUNTRY_BOTTOM_CHOOSE_WINNERS_TITLE')}</h3>
              <div className="bottom-choose-winners__body">
                <div className="bottom-choose-winners__left">
                  {stageBlocks}
                  <div className="bottom-choose-winners__text">{this.l10n('UNITED_COUNTRY_BOTTOM_CHOOSE_WINNERS_TEXT')}</div>
                </div>
                <div className="bottom-choose-winners__right">
                  <img src={choose_winners_img} alt="choose winners img" />
                </div>
              </div>
            </div>
          </div>
          {this.state.loader ? (canUseDOM ? <Preloader /> : null) : <FilesForDownload widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}/>}
        </div>
      </div>
    );
}
